import styled from 'styled-components';
import Copy from './copy.js';
import Icon from './icon.js';
const PlanTableIcon = styled(Copy).withConfig({ displayName: "brc-PlanTableIcon", componentId: "brc-5zg8cj" }) `
  text-align: center;
`;
export const FeatureName = styled(Copy).withConfig({ displayName: "brc-FeatureName", componentId: "brc-1je65i8" }) ``;
export const FeatureIcon = styled(PlanTableIcon).withConfig({ displayName: "brc-FeatureIcon", componentId: "brc-1x572w1" }) `
  & > ${Icon} {
    fill: ${({ theme }) => theme.mermaidGreen400};
  }
`;
export const MissingFeatureIcon = styled(PlanTableIcon).withConfig({ displayName: "brc-MissingFeatureIcon", componentId: "brc-1y8w0sb" }) `
  & > ${Icon} {
    fill: ${({ theme }) => theme.sebastianRed200};
  }
`;
export const StyledHR = styled.hr.withConfig({ displayName: "brc-StyledHR", componentId: "brc-1rhrqwt" }) `
  border-top: 1px solid ${({ theme }) => theme.neutral200};
`;
export const PlansTable = styled.div.withConfig({ displayName: "brc-PlansTable", componentId: "brc-1xglpbd" }) `
  display: grid;
  grid-template-columns: 3fr 1fr;
  align-items: flex-end;
  margin: 24px 0;

  & > ${StyledHR} {
    grid-column: 1 / -1;
  }

  & > ${FeatureIcon}, ${FeatureName}, ${MissingFeatureIcon} {
    border-top: 1px solid ${({ theme }) => theme.neutral200};
    align-self: flex-start;
  }

  & > ${FeatureIcon}, ${FeatureName}, ${MissingFeatureIcon} {
    padding: 16px 0;
  }
`;
PlansTable.Divider = StyledHR;
PlansTable.FeatureIcon = FeatureIcon;
PlansTable.MissingFeatureIcon = MissingFeatureIcon;
PlansTable.FeatureName = FeatureName;
export default PlansTable;
//# sourceMappingURL=plans-table.js.map